import React, { useContext } from 'react';
import Rating from './Rating';
import UserRating from './UserRating';
import UserIcon from '../../assets/img/user_icon.png';
import PrimaryButton from '../buttons/PrimaryButton';
import { WindowManagerContext } from '../context/WindowManager';
import ShareButtons from '../misc/ShareButtons';
import { TrackingContext } from '../context/Tracking';
import LVRLangenfeld from './profiles/LVRLangenfeld';

const ratingMapper = [
  {
    name: 'Team',
    key: 'team'
  },
  {
    name: 'Arbeitszeitmodell',
    key: 'arbeitszeiten'
  },
  {
    name: 'Weiterbildung',
    key: 'weiterbildung'
  },
  {
    name: 'Einarbeitung',
    key: 'einarbeitung'
  },
  {
    name: 'Infrastruktur',
    key: 'infrastruktur'
  },
  {
    name: 'Sonstiges',
    key: 'sonstiges'
  }
];

const shareProps = {
  url: ''
};

const orderByUsers = ratings => {
  const ratingOwnerAndTimes = {};
  ratings.forEach(rating => {
    const key = rating.owner + '' + rating.experience_time;
    if (Object.keys(ratingOwnerAndTimes).includes(key)) {
      ratingOwnerAndTimes[key].push(rating);
    } else {
      ratingOwnerAndTimes[key] = [rating];
    }
  });
  console.log(ratingOwnerAndTimes);
  return Object.entries(ratingOwnerAndTimes).map(([k, v]) => ({
    user: v[0].perspective,
    time: v[0].experience_time,
    recommendedFor: v[0].recommended_for || [],
    ratings: v,
    recommended: v[0].recommended
  }));
};

const sortByNewest = ratingsByUsers => {
  return ratingsByUsers.sort((a, b) => {
    try {
      if (parseInt(a.time) < parseInt(b.time)) return 1;
      if (parseInt(a.time) > parseInt(b.time)) return -1;
      return 0;
    } catch (error) {
      console.log(error);
      return -1;
    }
  });
};

const RatingsHolder = ({ ratings: ratingObjects, clinic, department }) => {
  const [ratings, setRatings] = React.useState([]);
  const [chosenRating, setChosenRating] = React.useState(null);
  const { openWindow } = useContext(WindowManagerContext);
  const { t, increaseRatingViews } = useContext(TrackingContext);

  React.useEffect(() => {
    if (ratingObjects) {
      const orderedObjects = orderByUsers(ratingObjects);
      setRatings(old => sortByNewest(orderedObjects));
      increaseRatingViews();
      /* if (orderedObjects.length === 1) {
        setChosenRating(orderedObjects[0]);
      } */
    }
  }, [ratingObjects]);

  React.useEffect(() => {
    t('action', 'user_ratings_visible');
  }, []);

  return (
    <div className='clinic-ratings-wrapper'>
      {
      parseInt(clinic.id) === 12071 && (
        <>
          <h2 style={{ fontWeight: 'bold' }}>Offene Stellen (4)</h2>
          <ul style={{ marginTop: 30 }}>
            <li><p onClick={() => window.location.replace('https://jobs.lvr.de/index.php?ac=jobad&id=2315')} style={{ color: 'grey', textDecoration: 'underline', cursor: 'pointer' }}>Assistenzärzt:in für die Psychiatrie</p></li>
            <li><p onClick={() => window.location.replace('https://jobs.lvr.de/index.php?ac=jobad&id=2174')} style={{ color: 'grey', textDecoration: 'underline', cursor: 'pointer' }}>Assistenzärzt:in für die psychiatrische Forensik</p></li>
            <li><p onClick={() => window.location.replace('https://jobs.lvr.de/index.php?ac=jobad&id=1754')} style={{ color: 'grey', textDecoration: 'underline', cursor: 'pointer' }}>Oberärzt:in für die Psychiatrie</p></li>
            <li><p onClick={() => window.location.replace('https://jobs.lvr.de/index.php?ac=jobad&id=2313')} style={{ color: 'grey', textDecoration: 'underline', cursor: 'pointer' }}>Fortgeschrittene:r Assistenzärzt:in oder Fachärzt:in für die Psychiatrie</p></li>
          </ul>
          <br />
        </>
      )
    }
      {!chosenRating && <h2 style={{ fontWeight: 'bold' }}>Community-Bewertungen</h2>}
      {
          ratings.length === 0 &&
            <p style={{ color: 'grey', textAlign: 'center' }}><br />Noch keine Bewertungen vorhanden.<br /></p>
        }
      <br />
      {/* {
        chosenRating
          ? (
            <>
              <img src={UserIcon} width={30} />&nbsp;&nbsp;
              {chosenRating.user}, <span style={{ fontSize: 'small' }}><i>{chosenRating.time}</i></span>
              <hr />
              <br />
              <p style={{ fontSize: 22 }}>
                <i className={chosenRating.recommended === 1 ? 'fa fa-thumbs-up' : chosenRating.recommended === -1 ? 'fa fa-thumbs-down' : 'fa fa-thumbs-down'} style={{ color: ratingColors[chosenRating.recommended], transform: chosenRating.recommended === 0 ? 'rotate(-90deg)' : null, fontSize: 28 }} />
                &nbsp;&nbsp;
                {
                chosenRating.recommended === 1
                  ? (
                    <>Empfehlung</>
                    )
                  : chosenRating.recommended === -1
                    ? (
                      <>Keine Empfehlung</>
                      )
                    : (
                      <>Neutrale Bewertung</>
                      )
              }
              </p>
              <hr />
              <br />
              <Rating {...chosenRating} />
            </>
            )
          : ( */}
      <>
        {
          ratings?.map((rating, i) => <UserRating style={{ marginBottom: 20 }} key={i} rating={rating} onClick={() => setChosenRating(rating)} />)
        }
      </>
      {
        ratings.length > 0 && (
          <PrimaryButton scale={1.2} onClick={() => openWindow('createRating', { clinic, department })}><i className='fa fa-plus' />&nbsp;&nbsp;Selber bewerten</PrimaryButton>
        )
      }

      {
          parseInt(clinic.id) === 12071 && (
            <>
              <br />
              <LVRLangenfeld />
            </>
          )
        }
      <br /><br />
      <h6 style={{ fontWeight: 'bold' }}>{
        ratings.length > 0
          ? <>Schick die Bewertungen dieser Klinik an deine <nobr>Leute :)</nobr></>
          : 'Kennst du jemanden, der/die hier arbeitet?'
        }
      </h6>
      <ShareButtons
        title='Klinikbewertungen auf Felix Medicus'
        summary={department ? 'Schau mal hier: Ich habe die Bewertungen vom ' + clinic?.name : 'Auf Felix Medicus gibt es jetzt Klinik-Bewertungen. Kannst du die ' + clinic?.name + ' nicht bewerten?'}
      />
      {/* {
        ratingMapper.map(category => {
          let positiveCounts = 0;
          let negativeCounts = 0;
          let undecidedCounts = 0;
          const categoryRatings = ratings[category.key]?.map(ratingObject => {
            if (ratingObjectTester(ratingObject)) {
              if (ratingObject.recommended === -1) negativeCounts++;
              if (ratingObject.recommended === 1) positiveCounts++;
              if (ratingObject.recommended === 0) undecidedCounts++;
              return ratingObject;
            } else {
              return null;
            }
          }).filter(r => r !== null) || [];
          const summedValue = getRatingValue({ n: negativeCounts, p: positiveCounts, u: undecidedCounts });
          return (
            <React.Fragment key={category.name}>
              <h5 className='rating-category-header'>
                <div style={{ backgroundColor: colorMapper[summedValue] }} />
                {category.name}
              </h5>
              <table style={{ clear: 'both' }} className='rating-item'>
                <tbody>
                  {
                    categoryRatings.map((rating, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            {ratingValueIconMapper[rating.recommended]}
                          </td>
                          <td>
                            <p className='rating-item' style={{ color: colorMapper[rating.recommended] }}>{rating.text}</p>
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            </React.Fragment>
          );
        })
      } */}
    </div>
  );
};

export default RatingsHolder;
